module.exports = __webpack_public_path__ + "static/media/antivirus-symantec.22442a5b.png";